import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import {
  requestRequestShippingQuote, 
  requestChangeDeliveryAddress, 
  requestSetDeliveryInstructions,
  requestProcessShipment, 
  requestAcceptShippingQuote, 
  requestHoldShipment, 
  requestReleaseShipmentHold,
  requestCreateBreakageReport
  } from "../actions/ShippingApiActions";
import { requestCreateNote } from "../notes/NotesActions";
import OrdersList from "./views/OrdersList";
import OrderDetails from "./views/OrderDetails";
import FilterPanel from "../components/panels/FilterPanel";
import SearchQueriesPanel from "../components/panels/SearchQueriesPanel";
import ShipFromWarehousePanel from "./panels/ShipFromWarehousePanel";
import ShippingInfoPanel from "./panels/ShippingInfoPanel";
import ShippingStatusPanel from "./panels/ShippingStatusPanel";
import TrackingPanel from "./panels/TrackingPanel";
import OrderActions from "./actions/OrderActions";
import LogPanel from "./panels/LogPanel";
import NotesPanel from "../notes/panels/NotesPanel";
import {getAllShopsWithAllOption} from "../lib/Shops";
import {getAllWarehouses, filterCourier, addAllWarehousesOption} from "../lib/Warehouses";
import {connect} from "react-redux";
import {graphql, withApollo} from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {List, fromJS, Map} from "immutable";
import {SHIPPING_ORDER_TYPE} from "../notes/notes";
import "./OrdersPage.css";

const statusFilterKey = "status";
const statusFilterDefaultOption = "not_delivered";
const statusFilterOptions = fromJS([
  {id: "all", label: "All Orders"},
  {id: "delivered", label: "Delivered"},
  {id: "replaced", label: "Replaced"},
  {id: "preparation", label: "In Preparation"},
  {id: "packaging", label: "Warehouse Packaging"},
  {id: "pickup_overdue", label: "Pickup Overdue"},
  {id: "not_delivered", label: "Not Delivered"},
  {id: "cancelled", label: "Cancelled"},
  {id: "hold", label: "On Hold"}
])

const typeFilterKey = "type";
const typeFilterOptions = fromJS([
  {id: "", label: "All Orders"},
  {id: "complimentary", label: "Complimentary"},
  {id: "replacement", label: "Replacement"},
  {id: "has_replacement", label: "Has Replacement"},
])

const searchOptions = fromJS([
  {prop: "orderId", label: "Order Id", type: "string"},
  {prop: "extOrderId", label: "Ext. Order Id", type: "string"},
  {prop: "name", label: "Name", type: "string"},
  {prop: "attName", label: "Att. Name", type: "string"},
  {prop: "email", label: "Email", type: "string"},
  {prop: "phoneNr", label: "Phone Nr.", type: "string"},
  {prop: "notes", label: "Notes", type: "string"},
  {prop: "courierId", label: "Courier Id", type: "string"},
])

const jurisdictionFilterKey = "shop_id";
const warehouseFilterKey = "warehouse_id";

class OrdersPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleViewOrderId = this.handleViewOrderId.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = {
      orderId: "",
      hasOrderSelection: false,
      selectedPanelId: "filters"
    }
  }

  componentDidMount() {
    if (this.props.route.page === "order") {
      this.setState({orderId: this.props.params.orderId});
    }
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.params.orderId !== this.props.params.orderId) {
      this.setState({orderId: this.props.params.orderId})
    }
  }


  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Shipment Orders";
    if (page === "order") {
      title = `${title} / ${this.state.orderId}`;
    }

    return (
      <div className="ShippingPage OrdersPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "order"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={page==="orders"} label="Filters" id="filters" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="orders"} label="Search" id="search" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="order" || this.state.hasOrderSelection} label="Properties" id="properties" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="order"} label="Warehouse" id="warehouse" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="order" || this.state.hasOrderSelection} label="Log" id="log" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="order" || this.state.hasOrderSelection} label="Notes" id="notes" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Create New Order" 
              show={page === "orders"}
              onClick={this.handleCreateNewOrder.bind(this)} />
            <ActionButton
              label="Annotate Order" 
              show={(page === "orders" && this.state.hasOrderSelection) || page === "order"}
              onClick={this.handleAnnotateOrder.bind(this)} />
            <ActionButton
              label="Generate Breakage Report" 
              show={page === "orders"}
              onClick={this.handleCreateBreakageReport.bind(this)} />
            {this.renderOrderActions(this.state.orderId, page)}
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderOrderActions(orderId, page) {
    if (page !== "order") return null;
    return (
      <OrderActions
        orderId={orderId}
        show={true}
        onChangeAddress={this.handleChangeAddress.bind(this)}
        onSetDeliveryInstructions={this.handleSetDeliveryInstructions.bind(this)}
        onAssignWarehouse={this.handleAssignWarehouse.bind(this)}
        onChangeWarehouse={this.handleChangeWarehouse.bind(this)}
        onProcessShipment={this.handleProcessShipment.bind(this)}
        onScheduleShipment={this.handleScheduleShipment.bind(this)}
        onUnscheduleShipment={this.handleUnscheduleShipment.bind(this)}
        onAddProduct={this.handleAddProduct.bind(this)}
        onRequestQuote={this.handleRequestQuote.bind(this)}
        onReserveStock={this.handleReserveStock.bind(this)}
        onAcceptQuote={this.handleAcceptQuote.bind(this)}
        onHoldShipment={this.handleHoldShipment.bind(this)}
        onReleaseShipmentHold={this.handleReleaseShipmentHold.bind(this)}
        onCancelOrder={this.handleCancelOrder.bind(this)}
        onVoidShipment={this.handleVoidQuote.bind(this)}
        onMarkAsComplimentary={this.handleMarkAsComplimentary.bind(this)}
        />
    )
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);
    switch(page) {
      case "orders":
        return (
          <OrdersList 
            selectedId={this.state.orderId} 
            onSelectionChange={this.handleSetSelection}
            onIdClick={this.handleViewOrderId}
            statusFilter={searchQueries.get(statusFilterKey, statusFilterDefaultOption)}
            typeFilter={searchQueries.get(typeFilterKey, "")}
            jurisdictionFilter={searchQueries.get(jurisdictionFilterKey, "")}
            warehouseFilter={searchQueries.get(warehouseFilterKey, "")}
            orderIdSearch={searchQueries.get("orderId", "")}
            extOrderIdSearch={searchQueries.get("extOrderId", "")}
            courierIdSearch={searchQueries.get("courierId", "")}
            nameSearch={searchQueries.get("name", "")}
            attNameSearch={searchQueries.get("attName", "")}
            emailSearch={searchQueries.get("email", "")}
            phoneNrSearch={searchQueries.get("phoneNr", "")}
            notesSearch={searchQueries.get("notes", "")}
            />
        )
      case "order":
        return (
          <OrderDetails
            orderId={this.state.orderId}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }


  renderPanels(page) {
    switch(page) {
      case "orders":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([ShippingStatusPanel, ShippingInfoPanel, TrackingPanel]));
        } else if (this.state.selectedPanelId === "log") {
          return this.buildPanels(List([LogPanel]));
        } else if (this.state.selectedPanelId === "search") {
          return this.buildPanels(List([SearchQueriesPanel]));  
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        } else {
          return this.buildPanels(List(["statusFilter", "typeFilter", "jurisdictionFilter", "warehouseFilter"]));
        }
      case "order":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([ShippingStatusPanel, ShippingInfoPanel]));
        } else if (this.state.selectedPanelId === "warehouse") {
          return this.buildPanels(List([ShipFromWarehousePanel]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        } else {
          return this.buildPanels(List([LogPanel]));          
        }
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    let searchQueries = Map(this.props.router.location.query);
    switch(component) {
      case "statusFilter":

        return <FilterPanel
          key="StatusFilterPanel"
          title="Status Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={this.handleSetStatusFilter.bind(this)}
          filter={searchQueries.get(statusFilterKey, statusFilterDefaultOption)}
          />
          
      case "typeFilter":
        return <FilterPanel
          key="TypeFilterPanel"
          title="Type Filter"
          expanded={true}
          options={typeFilterOptions}
          onClick={this.handleSetTypeFilter.bind(this)}
          filter={searchQueries.get(typeFilterKey, "")}
          />
          
      case "jurisdictionFilter":
        return <FilterPanel
          key="JurisdictionFilterOptions"
          title="Shop Filter"
          expanded={true}
          options={getAllShopsWithAllOption()}
          onClick={this.handleSetJurisdictionFilter.bind(this)}
          filter={searchQueries.get(jurisdictionFilterKey, "")}
          />

      case "warehouseFilter":
        let warehouses = getAllWarehouses();
        warehouses = filterCourier(warehouses);
        warehouses = addAllWarehousesOption(warehouses);
        return <FilterPanel
          key="WarehouseFilterPanel"
          title="Warehouse Filter"
          expanded={true}
          options={warehouses}
          onClick={this.handleSetWarehouseFilter.bind(this)}
          filter={searchQueries.get(warehouseFilterKey, "")}
          />

      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />

      case ShippingStatusPanel:
        return <ShippingStatusPanel key="ShippingStatusPanel" orderId={this.state.orderId} />

      case ShippingInfoPanel:
        return <ShippingInfoPanel key="ShippingInfoPanel" orderId={this.state.orderId} />

      case TrackingPanel:
        return <TrackingPanel key="TrackingPanel" orderId={this.state.orderId} />

      case ShipFromWarehousePanel:
        return <ShipFromWarehousePanel key="ShipFromWarehousePanel" orderId={this.state.orderId} />

      case LogPanel:
        return <LogPanel key="LogPanel" orderId={this.state.orderId} />
          
      case NotesPanel:
        return <NotesPanel key="NotesPanel" foreignType={SHIPPING_ORDER_TYPE} foreignId={this.state.orderId} />
      
      default:
        return null;      
    }
  }

  updateUrlQuery(query = Map()) {
    this.props.router.push({
      pathname: "/shipping/orders",
      query: query.toJS()
    });    
  }  

  setQueryKeyAndUpdate(key, val) {
    let queries = Map(this.props.router.location.query);
    if (val === "") {
      this.updateUrlQuery(queries.delete(key));
    } else {
      this.updateUrlQuery(queries.set(key, val));
    }
  }

  handleSetStatusFilter(item) {
    this.setQueryKeyAndUpdate(statusFilterKey, item.get("id"));
  }  

  handleSetTypeFilter(item) {
    this.setQueryKeyAndUpdate(typeFilterKey, item.get("id"));
  }  

  handleSetJurisdictionFilter(item) {
    this.setQueryKeyAndUpdate(jurisdictionFilterKey, item.get("id"));
  }  

  handleSetWarehouseFilter(item) {
    this.setQueryKeyAndUpdate(warehouseFilterKey, item.get("id"));
  }  

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }

  handleSetSelection(id) {
    this.setState({orderId: id, hasOrderSelection: true, selectedPanelId: "properties"});
  }

  handleViewOrderId(orderId) {
    this.setState({orderId: orderId, hasOrderSelection: true}) 
    this.props.router.push(`/shipping/orders/${orderId}`);    
  }  

  handleCreateNewOrder() {
    this.props.requestCreateShippingOrder(); 
  }

  handleAssignWarehouse() {
    this.props.requestAssignWarehouseToOrder(this.state.orderId);
  }

  handleChangeWarehouse() {
    this.props.requestChangeWarehouseForOrder(this.state.orderId);
  }

  handleChangeAddress() {
    this.props.requestChangeDeliveryAddress(this.state.orderId);
  }

  handleSetDeliveryInstructions() {
    this.props.requestSetDeliveryInstructions(this.state.orderId);
  }

  handleProcessShipment() {
    this.props.requestProcessShipment(this.state.orderId);
  }

  handleScheduleShipment() {
    this.props.requestScheduleShipment(this.state.orderId);
  }

  handleUnscheduleShipment() {
    this.props.requestUnscheduleShipment(this.state.orderId);
  }

  handleRequestQuote() {
    this.props.requestRequestShippingQuote(this.state.orderId);
  }

  handleReserveStock() {
    this.props.requestRequestStockReservation(this.state.orderId);
  }

  handleAcceptQuote() {
    this.props.requestAcceptShippingQuote(this.state.orderId);
  }

  handleHoldShipment() {
    this.props.requestHoldShipment(this.state.orderId);
  }

  handleReleaseShipmentHold() {
    this.props.requestReleaseShipmentHold(this.state.orderId);
  }

  handleVoidQuote() {
    this.props.requestVoidShippingQuote(this.state.orderId);
  }

  handleMarkAsComplimentary() {
    this.props.requestMarkShipmentAsComplimentary(this.state.orderId);
  }

  handleCancelOrder() {
    this.props.requestCancelShippingOrder(this.state.orderId);
  }

  handleAddProduct() {
    const result = this.props.client.readFragment({
      id: `shipping-order:${this.state.orderId}`,
      fragment: gql`
        fragment myFrag on ShippingOrder {
          jurisdictionId
        }
      `
    });
    this.props.requestAddProductToShippingOrder(this.state.orderId, result.jurisdictionId);
  }

  handleCreateShippingLabels() {
    let values = {
      orderId: this.state.orderId
    }
    this.props.createShippingLabels(values)
      .then((response) => {
        if (response.data.createShippingLabels.errors.length <= 0) {
          console.log("Creating shipping labels");
        } else {
          // let errors = createValidationErrors(response.data.placeOrder.errors);
          console.warn("Creating shipping labels ERROR", response.data.createShippingLabels.errors);
          // this.setState({errors: errors});
        }
      })
      .catch((err) => {
        console.warn("Creating shipping labels ERROR!!", err);
        // this.setState({errors: createErrors(err)});
      });     
  }

  handleSendDeliveryMessage() {
    console.log(this.state.orderId);
  }

  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.updateUrlQuery(searchQueries);
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.updateUrlQuery(emptySearchQueries);
  }  

  handleBack() {
    this.props.router.push(`/shipping/orders`);
  }  

  handleKeyDown(e) {
    if (e.key === "n" && e.ctrlKey) {
      this.handleCreateNewOrder()
    }
  }

  handleAnnotateOrder(e) {
    this.props.requestCreateNote(SHIPPING_ORDER_TYPE, this.state.orderId);  
  }

  handleCreateBreakageReport(e) {
    const searchQueries = Map(this.props.router.location.query);
    // We use the current filter for jurisdiction (defaults to all)
    const shopId = searchQueries.get(jurisdictionFilterKey, "");
    this.props.requestCreateBreakageReport(shopId);
  }
}


const CREATE_SHIPPING_LABELS = gql`
  mutation createShippingLabels($data: CreateShippingLabelsInput!) {
    createShippingLabels(input: $data) {
      errors { key message }
    }
  }
`;

const withMutations = compose(
  graphql(CREATE_SHIPPING_LABELS, {
    props: ({mutate}) => ({
      createShippingLabels: (data) => mutate({
        variables: { data: data }
      })
    })
  })
)

export default connect(null, {requestRequestShippingQuote, requestChangeDeliveryAddress, requestSetDeliveryInstructions, requestProcessShipment, requestAcceptShippingQuote, requestHoldShipment, requestReleaseShipmentHold, requestCreateNote, requestCreateBreakageReport})(withMutations(withApollo(OrdersPage)));